export const sidebarLeft = (
  <path
    d="M2 6L3 5H25L26 6V22L25 23H3L2 22V6ZM4 7V21H9V7H4ZM11 7V21H24V7H11ZM5 8.5H8V9.75H5V8.5ZM8 11.25H5V12.5H8V11.25ZM5 14H8V15.25H5V14Z"
    fill="currentColor"
  />
);
